/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetDistrictSchoolsR200ResponseInnerActiveIdpEnum = {
    Clever: 'clever',
    Csv: 'csv',
    ClassLink: 'class-link',
    ClassLinkRaw: 'class-link-raw',
    Renaissance: 'renaissance'
};
/**
 * @export
 */
export const GetDistrictSchoolsR200ResponseInnerIdentityProviderEnum = {
    Clever: 'clever',
    Csv: 'csv',
    ClassLink: 'class-link',
    ClassLinkRaw: 'class-link-raw',
    Renaissance: 'renaissance'
};
/**
 * Check if a given object implements the GetDistrictSchoolsR200ResponseInner interface.
 */
export function instanceOfGetDistrictSchoolsR200ResponseInner(value) {
    if (!('active' in value) || value['active'] === undefined)
        return false;
    if (!('city' in value) || value['city'] === undefined)
        return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined)
        return false;
    if (!('courseSubjectsByLicensing' in value) || value['courseSubjectsByLicensing'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('districtId' in value) || value['districtId'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('idpManaged' in value) || value['idpManaged'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('syncIdp' in value) || value['syncIdp'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
export function GetDistrictSchoolsR200ResponseInnerFromJSON(json) {
    return GetDistrictSchoolsR200ResponseInnerFromJSONTyped(json, false);
}
export function GetDistrictSchoolsR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'active': json['active'],
        'activeIdp': json['active-idp'] == null ? undefined : json['active-idp'],
        'administrativeArea': json['administrative-area'] == null ? undefined : json['administrative-area'],
        'city': json['city'],
        'classLinkSchoolId': json['class-link-school-id'] == null ? undefined : json['class-link-school-id'],
        'cleverSchoolId': json['clever-school-id'] == null ? undefined : json['clever-school-id'],
        'countryCode': json['country-code'],
        'courseSubjectsByLicensing': json['course-subjects-by-licensing'],
        'createdAt': (new Date(json['created-at'])),
        'crmAccountNumber': json['crm-account-number'] == null ? undefined : json['crm-account-number'],
        'crmId': json['crm-id'] == null ? undefined : json['crm-id'],
        'districtId': json['district-id'],
        'formattedAddressLines': json['formatted-address-lines'] == null ? undefined : json['formatted-address-lines'],
        'id': json['id'],
        'identityProvider': json['identity-provider'] == null ? undefined : json['identity-provider'],
        'idpManaged': json['idp-managed'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'licenseUtilizationNotificationsMutedAt': json['license-utilization-notifications-muted-at'] == null ? undefined : (new Date(json['license-utilization-notifications-muted-at'])),
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'name': json['name'],
        'ncesSchoolId': json['nces-school-id'] == null ? undefined : json['nces-school-id'],
        'pin': json['pin'] == null ? undefined : json['pin'],
        'postalCode': json['postal-code'] == null ? undefined : json['postal-code'],
        'renaissanceRPIdentifier': json['renaissance-r-p-identifier'] == null ? undefined : json['renaissance-r-p-identifier'],
        'sisId': json['sis-id'] == null ? undefined : json['sis-id'],
        'syncIdp': json['sync-idp'],
        'updatedAt': (new Date(json['updated-at'])),
    };
}
export function GetDistrictSchoolsR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'active': value['active'],
        'active-idp': value['activeIdp'],
        'administrative-area': value['administrativeArea'],
        'city': value['city'],
        'class-link-school-id': value['classLinkSchoolId'],
        'clever-school-id': value['cleverSchoolId'],
        'country-code': value['countryCode'],
        'course-subjects-by-licensing': value['courseSubjectsByLicensing'],
        'created-at': ((value['createdAt']).toISOString()),
        'crm-account-number': value['crmAccountNumber'],
        'crm-id': value['crmId'],
        'district-id': value['districtId'],
        'formatted-address-lines': value['formattedAddressLines'],
        'id': value['id'],
        'identity-provider': value['identityProvider'],
        'idp-managed': value['idpManaged'],
        'latitude': value['latitude'],
        'license-utilization-notifications-muted-at': value['licenseUtilizationNotificationsMutedAt'] == null ? undefined : (value['licenseUtilizationNotificationsMutedAt'].toISOString()),
        'longitude': value['longitude'],
        'name': value['name'],
        'nces-school-id': value['ncesSchoolId'],
        'pin': value['pin'],
        'postal-code': value['postalCode'],
        'renaissance-r-p-identifier': value['renaissanceRPIdentifier'],
        'sis-id': value['sisId'],
        'sync-idp': value['syncIdp'],
        'updated-at': ((value['updatedAt']).toISOString()),
    };
}
